import { render, staticRenderFns } from "./TableActionsMenu.vue?vue&type=template&id=12ce4a97&scoped=true&"
import script from "./TableActionsMenu.vue?vue&type=script&lang=js&"
export * from "./TableActionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./TableActionsMenu.vue?vue&type=style&index=0&id=12ce4a97&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ce4a97",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBottomSheet,VCard,VCol,VDivider,VMenu,VRow,VSheet,VSwitch})
